// @flow
import React, { PureComponent } from 'react';
import { socialNetworks } from 'utils/socialShareUtils';

type Props = {
  url: string,
  title: string,
  titleclass: string,
  clickTagManager: Function,
  parentClass?: string,
};

class FooterSocial extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    url: '#',
    title: '',
    titleclass:'mb-3',
    parentClass: '',
  };

  renderButtons = (): Array<React$Element<any>> => {
    const { clickTagManager } = this.props;
    const { url, title } = this.props;

    return Object.keys(socialNetworks).map(key => {
      const ShareButton = socialNetworks[key];
      const classNames = key === 'mail'
        ? 'btn btn--primary btn--social'
        : `btn btn--${key} btn--social`;

      const socialNetworkTitle = key.substr(0, 1).toUpperCase() + key.slice(1);

      const data = {
        className: `${classNames}${key === 'twitter' ? ' is-dark' : ''}`,
        url: (!url || url === '#' ) ? window.location.href : url,
        quote: (key === 'facebook') ? title : false,
        title: (key === 'twitter' || key === 'whatsapp') ? title : false,
        subject: (key === 'mail') ? title : false,
      };

      return (
        <ShareButton
          {... data}
          key={`${key}-share-button`}
          beforeOnClick={clickTagManager(key)}
        >
          <i className={`icon icon-${key} is-inline`} />
          <span>{socialNetworkTitle}</span>
        </ShareButton>
      );
    });
  };

  render() {
    const { titleclass, parentClass } = this.props;

    return (
      <div className={parentClass}>
        <h3 className={titleclass}>Partager</h3>
        <div className="block-share">
          {this.renderButtons()}
        </div>
      </div>
    );
  }
}
export default FooterSocial;
